import { types } from './categoria.actions'
import { Reducer } from '../../services/reducer.factory'
import storage from '../../services/stoage.service'

const initialState = {
  id: 'categoria',
  selectedFilters: [],
  showHideColumns: [
    {
      label: 'Código',
      value: {
        field: 'oid',
        header: 'Código',
        columnKey: 'oid',
        columnSortField: 'oid',
        sortable: true,
        filter: true,
        visible: true,
      },
    },
    {
      label: 'Descrição',
      value: {
        field: 'descricao',
        header: 'Descrição',
        columnKey: 'descricao',
        columnSortField: 'descricao',
        sortable: true,
        filter: true,
        visible: true,
      },
    },
    {
      label: 'Especialidade',
      value: {
        field: 'categoriaPai.value',
        header: 'Especialidade',
        columnKey: 'categoriaPai',
        columnSortField: 'categoriaPai.descricao',
        sortable: true,
        filter: true,
        visible: true,
        relacionamento: ['categoriaPai'],
        fieldJoin: 'descricao',
      },
    },
  ],
  columns: [],
  columnsLookup: [
    {
      field: 'oid',
      header: 'Código',
      columnKey: 'oid',
      sortable: true,
      filter: true,
      columnSortField: 'oid',
      visible: true,
    },
    {
      field: 'descricao',
      header: 'Descrição',
      columnKey: 'descricao',
      sortable: true,
      filter: true,
      columnSortField: 'descricao',
      visible: true,
    },
  ],
  currentRecord: {
    oid: '',
    descricao: '',
    categoriaPai: '',
  },
  lookupCategoria: {
    visible: false,
    modal: true,
    header: 'Categoria',
  },
  messages: null,
}

const reducer = new Reducer(initialState, types)

export function CRUDCategoriaReducer(state, action) {
  if (state) {
    state.messages = storage.getAppLabels('categoria')
  }
  state = reducer.execute(state, action)
  return execute(state, action)
}

function execute(state, action) {
  switch (action.type) {
    case types.SET_LOOKUP_CATEGORIA_VISIBLE:
      return setLoockupCategoriaVisible(state, action)
    case types.RESET:
      return reset(state, action)
    default:
      return state
  }
}

function setLoockupCategoriaVisible(state, action) {
  let lookupCategoria = state.lookupCategoria
  lookupCategoria = Object.assign({}, lookupCategoria, {
    visible: action.visible,
  })
  return Object.assign({}, state, { lookupCategoria })
}

function reset(state, action) {
  return { ...state, currentRecord: initialState.currentRecord, records: [], selectedFilters: [] }
}
